<!--
 * @Author: yangchuanqi
 * @Date: 2021-01-05 11:20:09
 * @LastEditTime: 2021-01-06 12:08:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\email\info.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link target="_blank" class="routerLink" to="/home">校园意见箱</router-link>
        &gt;
        <router-link target="_blank" class="routerLink" to="/message">通知公告</router-link>
        &gt; 正文
      </div>
    </div>
    <div class="orgTitle center" style="margin-top: 40px">
      {{ info.name }}
    </div>
    <div class="orgTime center">
      文字来源：本站原创  发布时间： {{ info.releaseTime }}
    </div>
    <div style="margin-top: 25px" v-html="info.content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.info = JSON.parse(decodeURIComponent(this.$route.query.record));
    },
  },
};
</script>

<style scoped>
.center {
  width: 100%;
  text-align: center;
}

.orgTitle {
  padding-top: 20px;
  font-family: 宋体;
  font-size: 22pt;
  font-weight: bold;
}

.orgTime {
  padding-top: 10px;
  font-size: 12px;
  color: #999;
}

.orgTitle2 {
  font-weight: bold;
  margin-top: 15px;
  font-family: 仿宋_GB2312;
  font-size: 14pt;
}
</style>
